module.exports = __webpack_public_path__ + "static/media/el-capitan.37047270.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/el-capitan.jpg
// module id = 289
// module chunks = 0